module.exports = __webpack_public_path__ + "img/logo_gsuite.7f878930.png";